import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import ThankYou from "@/pages/ThankYou";
import EarlyBird from "@/pages/EarlyBird";
import EarlyBirdThanks from "@/pages/EarlyBirdThanks";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookieBanner from "@/components/CookieBanner";
import { installCalendlyTracking } from "@/lib/calendly";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    installCalendlyTracking();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/tack/bekraftelse" element={<ThankYou />} />
          <Route path="/early-bird" element={<EarlyBird />} />
          <Route path="/early-bird/tack" element={<EarlyBirdThanks />} />
          <Route path="/integritetspolicy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
